var map = {
	"./adv.svg": 843,
	"./edgar.svg": 844,
	"./erm.svg": 845,
	"./group.svg": 846,
	"./home.svg": 847,
	"./lei.svg": 848,
	"./man.svg": 849,
	"./notepad.svg": 850,
	"./rca.svg": 851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 842;